var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showLastLog
    ? _c("div", { staticClass: "el-section" }, [
        _vm.lastLog && _vm.lastLog.error
          ? _c("p", { staticClass: "emd-text _size_small _align_center" }, [
              _c("i", { staticClass: "uil uil-exclamation-triangle" }),
              _vm._v(" " + _vm._s(_vm.$t("log-actions.detail.error")) + " "),
            ])
          : _c("p", { staticClass: "emd-text _size_small _align_center" }, [
              _vm._v(
                " " + _vm._s(_vm.$t("log-actions.detail.last-action")) + ": "
              ),
              _c("strong", [_vm._v(_vm._s(_vm.lastLog.action))]),
              _vm._v(" " + _vm._s(_vm.$t("log-actions.detail.at")) + " "),
              _c("strong", [
                _vm._v(
                  _vm._s(
                    _vm._f("dateFormat")(_vm.lastLog.timestamp, "dateAndHour")
                  )
                ),
              ]),
              _vm._v(" " + _vm._s(_vm.$t("log-actions.detail.for")) + " "),
              _c("strong", [_vm._v(_vm._s(_vm.lastLog.user_name))]),
            ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }